import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { Route, Switch } from "react-router";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./components/App";
import registerServiceWorker from "./registerServiceWorker";
import rootSaga from "./sagas";
import configureStore from "./config/store";
import configFonts from "./config/fonts";
import configFontAwesome from "./config/fontAwesome";

import "./app.css";

configFonts();
configFontAwesome();

const store = configureStore({});
store.runSaga(rootSaga);

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <Switch>
        <Route path="/jobs/:id" component={App} />
        <Route path="/" component={App} />
      </Switch>
    </Router>
  </Provider>,
  document.getElementById("root")
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js